import React, { useContext } from 'react';
import { ThemeSettings } from './ThemeSettings';
import { ThemeProviderCD } from '@cd/rhf';

import { XPropsStore } from './xprops';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';

export function ThemeProviderWithModes({ children }) {
	const { THEME_MODE, FONT_SIZE } = useContext(XPropsStore);

	return (
        <ThemeSettings
			mode={THEME_MODE}
			fontSize={FONT_SIZE}
			render={({ theme }) => (
				<StyledEngineProvider injectFirst>
					<ThemeProvider theme={theme}>
						<ThemeProviderCD theme={{ ...theme, mode: THEME_MODE }}>
							{children}
						</ThemeProviderCD>
					</ThemeProvider>
				</StyledEngineProvider>
			)}
		/>
    );
}
